import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const URL = 'https://www.unitedbarbell.com';

export default function QROverlay({ theme, show, onToggle }) {
  const isDark = theme === 'dark';

  const toggleBtn = {
    position: 'fixed',
    bottom: '2rem',
    left: '2rem',
    zIndex: 10,
    background: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
    border: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.1)'}`,
    borderRadius: '0.5rem',
    width: '2.2rem',
    height: '2.2rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: isDark ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.3)',
    transition: 'opacity 0.2s',
  };

  return (
    <>
      {show && (
        <div style={{
          position: 'fixed',
          bottom: '5.5rem',
          left: '2rem',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.6rem',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '0.75rem',
            padding: '0.75rem',
            boxShadow: isDark
              ? '0 0 0 1px rgba(255,255,255,0.08)'
              : '0 0 0 1px rgba(0,0,0,0.08)',
          }}>
            <QRCodeSVG value={URL} size={120} />
          </div>
          <div style={{
            fontSize: '0.78rem',
            fontWeight: 500,
            letterSpacing: '0.04em',
            color: isDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.45)',
            textAlign: 'center',
            maxWidth: '140px',
            lineHeight: 1.4,
          }}>
            Scan to share your memory
          </div>
        </div>
      )}
      <button style={toggleBtn} onClick={onToggle} title="Toggle QR code">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <rect x="0" y="0" width="6" height="6" rx="1" />
          <rect x="10" y="0" width="6" height="6" rx="1" />
          <rect x="0" y="10" width="6" height="6" rx="1" />
          <rect x="10" y="10" width="2" height="2" />
          <rect x="14" y="10" width="2" height="2" />
          <rect x="10" y="14" width="2" height="2" />
          <rect x="14" y="14" width="2" height="2" />
          <rect x="2" y="2" width="2" height="2" fill="white" />
          <rect x="12" y="2" width="2" height="2" fill="white" />
          <rect x="2" y="12" width="2" height="2" fill="white" />
        </svg>
      </button>
    </>
  );
}
